/**
 * Luma Group
 *
 * @author Robuust
 */

import { Controller } from '@hotwired/stimulus';

/**
 * CSRF controller.
 */
export default class extends Controller {
  static targets = ['input'];

  csrfTokenPromise = null;

  /**
   * Fetch CSRF token from Craft's session info endpoint.
   */
  initialize() {
    this.csrfTokenPromise = fetch('/actions/users/session-info', {
      method: 'GET',
      credentials: 'same-origin',
      headers: {
        Accept: 'application/json',
      },
    }).then((response) => response.json());
  }

  /**
   * Replace the placeholder element with a hidden input containing the CSRF token.
   *
   * @param {Element} target
   */
  async inputTargetConnected(target) {
    const sessionInfo = await this.csrfTokenPromise;
    const input = document.createElement('input');
    input.type = 'hidden';
    input.name = sessionInfo.csrfTokenName;
    input.value = sessionInfo.csrfTokenValue;
    target.replaceWith(input);
  }
}
